<template>
  <responsive-drawer-header :headerBg="theme.appBar.other.bg" :has-drawer="false">
    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:right>
      <cal-dav-link-button />
      <v-btn v-if="smAndDown" text @click="displayCalendar"
        >{{ $t('myduties.calendarBtnText') }}
        <v-icon>mdi-calendar-account</v-icon>
      </v-btn>
      <v-btn v-if="!smAndDown" text @click="previousMonth" icon>
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <div v-if="!smAndDown">{{ currentMonth }}</div>
      <v-btn v-if="!smAndDown" text @click="nextMonth" icon>
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn v-if="!smAndDown" text @click="selectToday"> {{ $t('today') }} </v-btn>
    </template>
  </responsive-drawer-header>
</template>

<script>
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import CalDavLinkButton from '@/components/buttons/CalDavLinkButton.vue';
import common from '@/mixins/common';
import MODULE_ID from '../moduleId';
import dutyMixin from '@/modules/myDuties/common/dutyMixin';
import configMixin from '@/mixins/configMixin';
import index from '@/modules/myDuties';

export default {
  name: 'DutyListHeader',
  mixins: [common, dutyMixin, configMixin],
  components: { ResponsiveDrawerHeader, CalDavLinkButton },
  computed: {
    color() {
      return this.theme.appBar.other.color;
    },
    gridModeIconColor() {
      return this.isBoxModeActive ? this.theme.appBar.other.color : '';
    },
    listModeIconColor() {
      return this.isListModeActive ? this.theme.appBar.other.color : '';
    },
    isBoxModeActive() {
      return this.dutiesDisplayMode === 'boxes';
    },
    isListModeActive() {
      return this.dutiesDisplayMode === 'list';
    },
    dutiesDisplayMode: {
      get() {
        let mode = this.$store.state[MODULE_ID].dutiesDisplayMode;
        if (!mode) {
          mode = localStorage.getItem('myDuty/displayMode') || this.defaultDutyView;
          this.$store.commit(`${MODULE_ID}/setDutiesDisplayMode`, mode);
        }
        return mode;
      },
      set(value) {
        if (Array.isArray(value)) value = value[0];
        localStorage.setItem('myDuty/displayMode', value);
        this.$store.commit(`${MODULE_ID}/setDutiesDisplayMode`, value);
        console.debug('dutiesDisplayMode=', value);
      },
    },
    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },
    defaultDutyView() {
      return this.moduleConfig?.defaultDutyView ? this.moduleConfig?.defaultDutyView : 'list';
    },
  },
  methods: {
    back() {
      this.$router.push({ name: 'myDuties', params: {} });
    },

    displayCalendar() {
      this.$store.commit('meinDienst/setIsSplitViewCalendarVisible', true, { root: true });
    },
  },
};
</script>

<style scoped></style>
